import { useEffect, useRef, useState } from "react";
import { ChevronRight } from "lucide-react";
import CompanyImage from "../../assets/images/final.png";
import logo from "../../assets/images/Logo.png";

import CloseIcon from "../../assets/icons/DELETE __ DARK.svg";
import Winner from "../../assets/icons/winner.svg";
import { useGetTournamentGroubMatchesQuery } from "../../lib/redux/services/Api";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Loader from "../../components/skeletons/Loader";
import { toJpeg } from "html-to-image";
import { toPng } from "html-to-image";
import ChartTeamMatchBox from "../../components/league-tournament/ChartTeamMatchBox";
import ChartTeamBox from "../../components/league-tournament/ChartTeamBox";
import ImageIcon from "../../components/global/ImageIcon";
import LeaguesIcon from "../../assets/icons/LeaguesIcon";
import { cn, getTeamPosition } from "../../utils/utils";

import ResultsColumnCharts from "../../components/league-tournament/ResultsColumnCharts";
import ChartControlls from "../../components/league-tournament/ChartControlls";
import InfoControll from "../../components/league-tournament/InfoControll";
type Props = {
  isShareMode?: boolean;
};

const sortPhasesFn = (data: any) => {
  return data.sort(
    (a: any, b: any) =>
      parseInt(a.match_code.substr(1)) - parseInt(b.match_code.substr(1))
  );
};
const RoundOf32 = ({
  groupedMatches,
  generalINfo,
}: {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
}) => {
  console.log('form round 32');
  
  const leftPhases = sortPhasesFn(
    groupedMatches["Phase 1"].filter((group: any) => group.group === "L")
  );
  const leftKnockoutsPhase = sortPhasesFn(
    groupedMatches["Round of 16"].filter(
      (group: any) =>
        group.group === "L" 
    )
  );
  const rightKnockoutsPhase = sortPhasesFn(
    groupedMatches["Round of 16"].filter(
      (group: any) =>
        group.group === "R" 
    )
  );
  
  const leftQuarterPhase = sortPhasesFn(
    groupedMatches["Quarter Final"].filter(
    (group: any) => group.group === "L"
  )
  );
  const rightQuarterPhase = sortPhasesFn(
    groupedMatches["Quarter Final"].filter(
    (group: any) => group.group === "R"
  )
  );
  const LeftSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "L"
  );
  const RightSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "R"
  );
  const rightPhases = sortPhasesFn(
    groupedMatches["Phase 1"].filter((group: any) => group.group === "R")
  );
  console.log(leftPhases);
  console.log(leftKnockoutsPhase);
  console.log(leftQuarterPhase);

  
  
  
  
  
  const elementRef = useRef(null);
  const finalMatch = groupedMatches?.Final?.find(
    (item: any) => item.final_type === "winner"
  );
  const thirdPlaceMatch = groupedMatches?.["3rd Place"].find(
    (item: any) => item.final_type === "loser"
  );
  const htmlToImageConvert = () => {
    //@ts-ignore
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "trophy.jpg";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="w-full h-dvh flex flex-col  bg-white overflow-y-auto customScroll min-w-[1200px]">
      <div className="relative w-full h-fit ">
        {groupedMatches && <InfoControll generalINfo={generalINfo} />}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full  grid grid-cols-12 grid-rows-1  bg-white pt-[150px] pb-[100px]  h-fit"
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-2  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(8).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] min-h-[120px]  pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>
            <ResultsColumnCharts
              currentStage={leftKnockoutsPhase}
              previousStage={leftPhases}
              rowsNumber={4}
            />
            <ResultsColumnCharts
              currentStage={leftQuarterPhase}
              previousStage={leftKnockoutsPhase}
              rowsNumber={2}
            />
            <ResultsColumnCharts
              currentStage={LeftSemiFinalPhases}
              previousStage={leftQuarterPhase}
              rowsNumber={1}
            />

            <div className="col-span-2  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white relative">
              <div className="h-[20vh]   font-bold text-lg  w-full mx-auto  rounded-md flex justify-center items-center text-primary dark:text-white  z-20 relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      type="Quarter"
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[max(10vh,60px)] h-full w-full mx-auto relative">
                    <ChartTeamMatchBox
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      data={thirdPlaceMatch}
                      type="Quarter"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[12%] bottom-[50%] w-[124%] h-[calc(100%+max(10vh,60px))] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>
              </div>
              <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
            </div>

            <ResultsColumnCharts
              currentStage={RightSemiFinalPhases}
              previousStage={rightQuarterPhase}
              rowsNumber={1}
              postion={"right"}
            />
            <ResultsColumnCharts
              currentStage={rightQuarterPhase}
              previousStage={rightKnockoutsPhase}
              rowsNumber={2}
              postion={"right"}
            />
            <ResultsColumnCharts
              currentStage={rightKnockoutsPhase}
              previousStage={rightPhases}
              rowsNumber={4}
              postion={"right"}
            />
            <div className=" col-span-2  flex flex-col justify-around items-center gap-1 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(8).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pr-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-r-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex items-center -top-7 right-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {rightPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex items-center bottom-0 right-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {rightPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                      <div className="h-[20vh] min-h-[120px]  pr-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <ChartControlls htmlToImageConvertFn={htmlToImageConvert} />
    </div>
  );
};
const RoundOf16 = ({
  groupedMatches,
  generalINfo,
}: {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
}) => {
  const [searchParams] = useSearchParams();
  const leftPhases = sortPhasesFn(
    groupedMatches["Phase 1"].filter((group: any) => group.group === "L")
  );
  const rightPhases = sortPhasesFn(
    groupedMatches["Phase 1"].filter((group: any) => group.group === "R")
  );
  const leftKnockoutsPhase = groupedMatches["Quarter Final"].filter(
    (group: any) =>
      group.group === "L" 
  );
  const rightKnockoutsPhase = groupedMatches["Quarter Final"].filter(
    (group: any) =>
      group.group === "R" 
  );
  const LeftSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "L"
  );
  const RightSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "R"
  );
  const finalMatch = groupedMatches?.Final?.find(
    (item: any) => item.final_type === "winner"
  );
  const thirdPlaceMatch = groupedMatches?.["3rd Place"].find(
    (item: any) => item.final_type === "loser"
  );
  const elementRef = useRef(null);
  const htmlToImageConvert = () => {
    //@ts-ignore
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "trophy.jpg";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="w-full h-dvh flex flex-col  bg-white overflow-y-auto customScroll min-w-[1200px]">
      <div className="relative w-full h-fit ">
        {groupedMatches && (
          <div className="flex justify-between absolute z-50 p-6 items-center w-full ">
            <div className="club flex items-center gap-2 flex-1">
              <img
                loading="lazy"
                src={generalINfo.club_id.logo}
                alt=""
                width={100}
                height={100}
                className="rounded-full w-[80px] h-[80px] object-cover"
              />
              <span className="text-lg text-primary dark:text-white font-bold">
                {generalINfo.club_id.name}
              </span>
            </div>
            <div className="p-2 px-4  bg-white rounded-l-full rounded-r-full min-w-[200px] flex flex-col border border-primary flex-1 max-w-[250px]">
              <div className="flex gap-4 pr-10">
                {generalINfo?.poster_url && (
                  <img
                    loading="lazy"
                    src={generalINfo?.poster_url}
                    alt=""
                    className="rounded-full w-[60px] h-[60px] object-cover bg-red-100"
                  />
                )}
                <div
                  className={cn(
                    "flex  gap-2",
                    generalINfo?.poster_url && "flex-col"
                  )}
                >
                  <h3>{searchParams.get("name")}</h3>
                  <p>{generalINfo?.tournament_type}</p>
                </div>
              </div>
            </div>
            <div className="sponsors flex items-center gap-2 flex-1 justify-end ">
              {generalINfo.sponsor_ids.map((item: any) => {
                if (item.logo_url) {
                  return (
                    <img
                      loading="lazy"
                      src={item.logo_url}
                      alt=""
                      width={40}
                      height={40}
                      className="rounded-full w-[80px] h-[80px] object-cover border border-primary"
                    />
                  );
                } else return null;
              })}
            </div>
          </div>
        )}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full  grid grid-cols-12 grid-rows-1  bg-white pt-[150px] pb-[100px]  h-fit"
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(4).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] min-h-[120px]  pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>

            <ResultsColumnCharts
              currentStage={leftKnockoutsPhase}
              previousStage={leftPhases}
              rowsNumber={2}
              baseHight={60}
            />
            <ResultsColumnCharts
              currentStage={LeftSemiFinalPhases}
              previousStage={leftKnockoutsPhase}
              rowsNumber={1}
              baseHight={60}
            />

            <div className="col-span-2  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white relative">
              <div className="h-[20vh]   font-bold text-lg  w-full mx-auto  rounded-md flex justify-center items-center text-primary dark:text-white  z-20 relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      type="Quarter"
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[max(10vh,60px)] h-full w-full mx-auto relative">
                    <ChartTeamMatchBox
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      data={thirdPlaceMatch}
                      type="Quarter"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[5%] bottom-[50%] w-[110%] h-[calc(100%+max(10vh,60px))] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>
              </div>
              <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
            </div>

            <ResultsColumnCharts
              currentStage={RightSemiFinalPhases}
              previousStage={rightKnockoutsPhase}
              rowsNumber={1}
              postion={"right"}
              baseHight={60}
            />
            <ResultsColumnCharts
              currentStage={rightKnockoutsPhase}
              previousStage={rightPhases}
              rowsNumber={2}
              postion={"right"}
              baseHight={60}
            />

            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(4).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pr-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-r-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex items-center -top-7 right-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {rightPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex items-center bottom-0 right-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {rightPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                      <div className="h-[20vh] min-h-[120px]  pr-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <ChartControlls htmlToImageConvertFn={htmlToImageConvert} />
    </div>
  );
};
const QuarterFinal = ({
  groupedMatches,
  generalINfo,
}: {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
}) => {
  console.log(groupedMatches);
  const leftPhases = groupedMatches["Phase 1"].filter(
    (group: any) => group.group === "L"
  );
  console.log(leftPhases);

  const rightPhases = groupedMatches["Phase 1"].filter(
    (group: any) => group.group === "R"
  );

  const LeftSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "L"
  );
  const RightSemiFinalPhases = groupedMatches["Semi Final"].filter(
    (group: any) => group.group === "R"
  );

  const [searchParams] = useSearchParams();
  const finalMatch = groupedMatches?.Final.find(
    (item: any) => item.final_type === "winner"
  );
  //const finalMatch = groupedMatches?.Final[1]
  const thirdPlaceMatch = groupedMatches?.["3rd Place"].find(
    (item: any) => item.final_type === "loser"
  );
  //const thirdPlaceMatch = groupedMatches?.Final[0]
  const elementRef = useRef(null);
  const navigate = useNavigate();
  const htmlToImageConvert = () => {
    //@ts-ignore
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "trophy.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="w-full h-dvh flex flex-col  bg-white overflow-y-auto customScroll min-w-[1200px]">
      <div className="relative w-full h-fit min-h-[573px] ">
        {groupedMatches && <InfoControll generalINfo={generalINfo} />}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full h-fit grid grid-cols-12 grid-rows-1  bg-white pt-[150px] pb-[100px]  "
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(2).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] min-h-[120px]  pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={leftPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          leftPhases[index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {leftPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(leftPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftPhases[index].winner?.id &&
                                leftPhases[index].winner?.id ===
                                  leftPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>

            <ResultsColumnCharts
              currentStage={LeftSemiFinalPhases}
              previousStage={leftPhases}
              rowsNumber={1}
              postion={"left"}
              baseHight={30}
            />

            <div className="col-span-4  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white relative">
              {/* <div className='h-[20vh] pl-4 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative'>
            <ChartTeamBox data={finalMatch}  />
         
          </div> */}
              <div className="h-[20vh]   font-bold text-lg  w-[80%] mx-auto  rounded-md flex justify-center items-center text-primary dark:text-white  z-20 relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      type="Quarter"
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[max(10vh,60px)] h-full w-[80%] mx-auto relative">
                    <ChartTeamMatchBox
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      data={thirdPlaceMatch}
                      type="Quarter"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[20%] bottom-[50%] w-[140%] h-[calc(100%+max(10vh,60px))] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>
                {/* {groupedMatches["Final"] && finalMatch.winner?.name ||finalMatch.match_code}
          <img loading="lazy" src={VictoryIcon} width={40} height={40} alt="" className='absolute bottom-0 right-0' /> */}
              </div>
              <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
            </div>

            <ResultsColumnCharts
              currentStage={RightSemiFinalPhases}
              previousStage={rightPhases}
              rowsNumber={1}
              postion={"right"}
              baseHight={30}
            />

            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(2).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]    w-full pr-5 rounded-lg  text-center flex items-center relative">
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-r-0 rounded-md rounded-r-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex text-[#747474] items-center -top-7 right-4  font-digital gap-1 text-lg">
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {rightPhases[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          rightPhases[index].winner && (
                            <ul className="absolute flex text-[#747474] items-center bottom-0 right-4  font-digital gap-1 text-lg">
                              {rightPhases[index].winner?.id &&
                                rightPhases[index].winner?.id ===
                                  rightPhases[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {rightPhases[index].team_line_ids[1]?.score_1}{" "}
                              </li>
                              {parseInt(rightPhases[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightPhases[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                      </div>
                      <div className="w-[70%] h-[20vh] min-h-[120px]  flex-col gap-2  pr-5 rounded-lg  text-center flex items-center relative">
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={rightPhases[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <ChartControlls htmlToImageConvertFn={htmlToImageConvert} />
    </div>
  );
};
const SimiFinal = ({
  groupedMatches,
  generalINfo,
}: {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
}) => {
  const finalMatch = groupedMatches?.Final.find(
    (item: any) => item.final_type === "winner"
  );
  const thirdPlaceMatch = groupedMatches?.["3rd Place"].find(
    (item: any) => item.final_type === "loser"
  );

  const elementRef = useRef(null);
  const htmlToImageConvert = () => {
    //@ts-ignore
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl: any) => {
        const link = document.createElement("a");
        link.download = "trophy.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  return (
    <div className="w-full h-dvh flex flex-col  bg-white">
      <div className="relative w-full h-full">
        {groupedMatches && <InfoControll generalINfo={generalINfo} />}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full h-full grid grid-cols-6 grid-rows-1  bg-white place-content-start"
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-2  flex flex-col justify-around items-start gap-2 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(1).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={groupedMatches["Phase 1"][index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={groupedMatches["Phase 1"][index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          groupedMatches["Phase 1"][index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {
                                  groupedMatches["Phase 1"][index]
                                    .team_line_ids[0]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Phase 1"][index].set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][index]
                                        .team_line_ids[0]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][index]
                                        .team_line_ids[0]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {groupedMatches["Phase 1"][index].winner?.id &&
                                groupedMatches["Phase 1"][index].winner?.id ===
                                  groupedMatches["Phase 1"][index]
                                    .team_line_ids[0]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          groupedMatches["Phase 1"][index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {
                                  groupedMatches["Phase 1"][index]
                                    .team_line_ids[1]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Phase 1"][index].set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][index]
                                        .team_line_ids[1]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][index]
                                        .team_line_ids[1]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {groupedMatches["Phase 1"][index].winner?.id &&
                                groupedMatches["Phase 1"][index].winner?.id ===
                                  groupedMatches["Phase 1"][index]
                                    .team_line_ids[1]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className=" col-span-2  flex flex-col justify-around items-start gap-1 rounded-lg font-bold text-lg text-primary dark:text-white relative">
              <div className="h-[20vh] w-full pr-4 rounded-lg  text-center flex items-center relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      type="Semi"
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Phase 1"]}
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[10vh] h-full w-[80%] mx-auto relative">
                    <ChartTeamMatchBox
                      data={thirdPlaceMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Phase 1"]}
                      type="Semi"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[20%] bottom-[50%] w-[140%] h-[calc(100%+10vh)] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>

                <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
              </div>
            </div>

            <div className=" col-span-2  flex flex-col justify-around items-start gap-2 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Phase 1"] &&
                new Array(1).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh]   w-full pr-5 rounded-lg  text-center flex items-center relative">
                      <div className="h-[12vh] border border-secondary w-[30%] border-r-0 rounded-md rounded-r-none relative text-sm">
                        {groupedMatches["Phase 1"] &&
                          groupedMatches["Phase 1"][1 + index].winner && (
                            <ul className="absolute flex text-[#747474] items-center -top-7 right-4  font-digital gap-1 text-lg">
                              {groupedMatches["Phase 1"][1 + index].winner
                                ?.id &&
                                groupedMatches["Phase 1"][1 + index].winner
                                  ?.id ===
                                  groupedMatches["Phase 1"][1 + index]
                                    .team_line_ids[0]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {
                                  groupedMatches["Phase 1"][1 + index]
                                    .team_line_ids[0]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Phase 1"][1 + index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][1 + index]
                                        .team_line_ids[0]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][1 + index]
                                        .team_line_ids[0]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                        {groupedMatches["Phase 1"] &&
                          groupedMatches["Phase 1"][1 + index].winner && (
                            <ul className="absolute flex text-[#747474] items-center bottom-0 right-4  font-digital gap-1 text-lg">
                              {groupedMatches["Phase 1"][1 + index].winner
                                ?.id &&
                                groupedMatches["Phase 1"][1 + index].winner
                                  ?.id ===
                                  groupedMatches["Phase 1"][1 + index]
                                    .team_line_ids[1]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {
                                  groupedMatches["Phase 1"][1 + index]
                                    .team_line_ids[1]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Phase 1"][1 + index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][1 + index]
                                        .team_line_ids[1]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Phase 1"][1 + index]
                                        .team_line_ids[1]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                      </div>
                      <div className="w-[70%] h-[20vh] flex-col gap-2  pr-5 rounded-lg  text-center flex items-center relative">
                        <ChartTeamBox
                          data={groupedMatches["Phase 1"][1 + index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={groupedMatches["Phase 1"][1 + index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>

                      {/* <ChartTeamMatchBox data={groupedMatches["Phase 1"][2 +index]}  type='Quarter'/> */}
                      {/* <div className='flex-1 bg-[#1E18501A] h-full flex justify-center items-center'>{groupedMatches["Phase 1"][2 +index].teams.split('X')[0]}</div>
          <span className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>{groupedMatches["Phase 1"][2 +index].match_code}</span>
          <div className='flex-1 bg-[#EF46261A] h-full flex justify-center items-center'>{groupedMatches["Phase 1"][2 +index].teams.split('X')[1]}</div> */}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <ChartControlls htmlToImageConvertFn={htmlToImageConvert} />
    </div>
  );
};

const generateMap = (
  groupedMatches: { [key: string]: any },
  generalINfo: any
) => {
  switch (groupedMatches["Phase 1"].length) {
    case 16:
      return (
        <RoundOf32 groupedMatches={groupedMatches} generalINfo={generalINfo} />
      );
    case 8:
      return (
        <RoundOf16 groupedMatches={groupedMatches} generalINfo={generalINfo} />
      );
    case 4:
      return (
        <QuarterFinal
          groupedMatches={groupedMatches}
          generalINfo={generalINfo}
        />
      );
    default:
      return (
        <SimiFinal groupedMatches={groupedMatches} generalINfo={generalINfo} />
      );
  }
};
function TournamentFinalMapPage({ isShareMode = false }: Props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [groupedMatches, setGroupedMatches] = useState<{ [key: string]: any }>(
    {}
  );
  const [generalINfo, setGeneralInfo] = useState<any>({});
  const { data: matches, isFetching } = useGetTournamentGroubMatchesQuery({
    id: id,
    stage: "knockouts",
  });
  useEffect(() => {
    // Reshape the data on component mount
    if (matches?.data) {
      const grouped = matches?.data.knockouts.reduce((acc: any, match: any) => {
        if (!acc[match.stage]) {
          acc[match.stage] = [];
        }
        acc[match.stage].push(match);
        return acc;
      }, {});
      console.log(grouped);
      setGeneralInfo({
        court: matches?.data.knockouts[0].court,
        sponsor_ids: matches?.data?.sponsor_ids,
        tournament_type: matches?.data?.tournament_type || "",
        poster_url: matches?.data.knockouts[0]?.poster_url || "",
        club_id: matches?.data?.club_id,
      });

      setGroupedMatches(grouped);
    }
  }, [matches]);

  if (isFetching) {
    return (
      <div className="w-full h-dvh flex overflow-y-auto customScroll  flex-col  bg-white justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className="w-full h-dvh flex flex-col  bg-white  overflow-y-auto customScroll ">
        {!isShareMode && (
          <div className="header py-2 px-2 bg-primary text-white flex gap-4 items-center justify-between min-w-[1180px] overflow-hidden">
            <div className=" flex gap-4 items-center flex-1">
              <ImageIcon Icon={LeaguesIcon} width={40} height={40} />

              <div className="flex gap-2 items-center">
                <span
                  className="font-bold text-lg cursor-pointer"
                  onClick={() => {
                    if (!isShareMode) {
                      navigate("/competitive/tournaments");
                    }
                  }}
                >
                  Tournaments
                </span>{" "}
                <ChevronRight size={15} />{" "}
                <span className="font-bold text-lg">Final</span>
              </div>
            </div>
            <div className="logo flex justify-center flex-[3]">
              <img loading="lazy" src={logo} alt="" />
            </div>
            <div className="close flex-1 flex justify-end">
              <img
                loading="lazy"
                src={CloseIcon}
                alt=""
                width={28}
                height={28}
                className="cursor-pointer"
                onClick={() => navigate("/competitive/tournaments")}
              />
            </div>
          </div>
        )}
        {groupedMatches["Phase 1"] && generateMap(groupedMatches, generalINfo)}
      </div>
    </>
  );
}

export default TournamentFinalMapPage;
